import {
  keepPreviousData,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

import { appQueryKeys } from "@/app/data/appQueryKeys";
import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import type { DebugProblemOccurrencesQueryType } from "@reflag/shared/eventAPI";

export function useDebugProblemOccurrence(
  params: Omit<DebugProblemOccurrencesQueryType, "envId">,
) {
  const { appId, envId } = useEnvironment();
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: appQueryKeys.debugProblemOccurrence(appId, envId, params),
    queryFn: async ({ signal }) => {
      const response =
        await api.get<"/apps/:appId/debug-events/problems/occurrences">(
          `/apps/${appId}/debug-events/problems/occurrences`,
          { params: { envId, ...params }, signal },
        );
      if (response.data.event && params.direction !== "exact") {
        queryClient.setQueryData(
          appQueryKeys.debugProblemOccurrence(appId, envId, {
            ...params,
            timestamp: response.data.event.timestamp,
            eventId: response.data.event.id,
            direction: "exact",
          }),
          response.data,
        );
      }
      return response.data;
    },
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
